import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavigationItemIconWrapper } from 'components/navigation_drawer/styled';
import { memo, ReactNode } from 'react';
import * as React from 'react';

type NavigationItemIconProps = Readonly<{
    id: string;
    /**
     * The Font Awesome icon for the navigation item.
     */
    icon?: IconProp;
    /**
     * A non-font awesome icon for the navigation item.
     */
    customIcon?: ReactNode;
}>;

function NavigationItemIconImpl(
    { id, icon, customIcon }: NavigationItemIconProps,
    ref: React.Ref<HTMLDivElement>
) {
    return (
        <NavigationItemIconWrapper ref={ref} id={id}>
            {icon && <FontAwesomeIcon className="f-18" icon={icon} />}
            {customIcon !== undefined && customIcon}
        </NavigationItemIconWrapper>
    );
}

export const NavigationItemIcon = memo(React.forwardRef(NavigationItemIconImpl));
